// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__1YhWH","options":"AnswerScale_options__2wvN1","selected":"AnswerScale_selected__3_ugb"};